import type { IExtractApiParams } from "@routes/types.ts";
import { generateApiPath } from "@routes/generatePath.ts";

const pathBase = `/prescriptions/histories/:type`;

type IPathBaseParams = IExtractApiParams<typeof pathBase>;

export const histories = {
  get: (params: IPathBaseParams) => generateApiPath(pathBase, params),
};
